(function(){
     'use strict';

     angular
        .module('appback')
        .factory('UserService', UserService);

    UserService.$inject = ['$http'];

    function UserService($http){

        var service= {
           registrarCentro:registrarCentro,
           getCentroUser:getCentroUser,
           guardarCentro:guardarCentro,
           registrarUsuario:registrarUsuario,
           recuperarPass:recuperarPass,
           cambiarPass:cambiarPass
           
        };

        return service;
 		function registrarCentro(newCentro,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               centro:newCentro,
               lang_id:lang_id
            });
            $http.post('/uranolab/registrarcentro', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function recuperarPass(datos,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               datos:datos,
               lang_id:lang_id
            });
            $http.post('/uranolab/recuperarpass', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function cambiarPass(newpass,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               newpass:newpass,
               lang_id:lang_id
            });
            $http.post('/uranolab/newpass', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        

        
        function registrarUsuario(registro,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               registro:registro,
               lang_id:lang_id
            });
            $http.post('/uranolab/registrarusuario', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getCentroUser(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/uranolab/getcentrouser', { params : { } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function guardarCentro(info,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               info:JSON.stringify(info)
            });
            $http.post('/uranolab/guardarcentro', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

       

    }
})();